module.exports = __webpack_public_path__ + "static/media/12UNCTAD13.06b0cb5b.jpg";